<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <title-text />
        </b-col>
        <b-col cols="12">
          <summary-text />
        </b-col>
        <b-col cols="12" md="6">
          <ordering />
        </b-col>
        <b-col cols="12" md="6">
          <service-categories />
        </b-col>
        <b-col cols="12">
          <content-text />
        </b-col>
      </b-row>
    </b-card>
    <image-card />
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'

import TitleText from '@/views/Admin/Services/elements/Title.vue'
import SummaryText from '@/views/Admin/Services/elements/Summary.vue'
import ContentText from '@/views/Admin/Services/elements/Content.vue'
import ImageCard from '@/views/Admin/Services/elements/Image.vue'
import Ordering from '@/views/Admin/Services/elements/Ordering.vue'
import ServiceCategories from '@/views/Admin/Services/elements/ServiceCategories.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    SummaryText,
    ContentText,
    ImageCard,
    Ordering,
    ServiceCategories,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['services/dataItem']
    },
  },
}
</script>
